import { render } from "./userRecord.vue?vue&type=template&id=45925766"
import script from "./userRecord.vue?vue&type=script&lang=js"
export * from "./userRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__